import React from 'react';
import FsPlayer from '../../shared/components/FsPlayer';
import VideoThumb from './VideoModalThumbnail'
import { StyleSheet, css } from 'aphrodite/no-important';
import { styles } from './styles/VideoModalStyles';


class VideoModalList extends React.Component {
    constructor(props){
        super(props);

        this.title = this.props.title;
        this.videos = this.props.videos || [];
        this.state = { activeIndex: 0 };

        this.setActiveState = (index) => this.setState({activeIndex: index}); 

        //passing the callback which returns the post the user clicks on 
        this.updateCurrentPost = this.props.onClick;

        this.updateDetails = (e) => {
            return (this.props.showDetails && this.props.showDetails(e));
        };

    }

    componentDidMount() {
        this.cont.addEventListener('scroll', this.updateDetails);
    }
    componentWillUnmount() {
        this.cont.removeEventListener('scroll', this.updateDetails);
    }

    render() {
        return (
            <div> 
                <h3 className={css(styles.compTitle)}> {this.title} </h3>
                <div ref={elem => this.cont = elem} className={css(styles.vmMoreCont) + " vm-more-videos"}>
                    {   this.videos ?
                            this.videos.map((item, index) => {
                                return <VideoThumb post={item} index={index} isActive={this.state.activeIndex === index} onClick={this.updateCurrentPost}></VideoThumb>
                            })
                        : 
                        <div></div>
                    }
                    {  
                        this.props.enableShowMore && <a href="javascript:;" className={css(styles.showMore)}> Show More </a>
                    }
                </div>
            </div>
        )
    }
}

export default VideoModalList;


// WEBPACK FOOTER //
// ./react-app-src/videoModal/components/VideoModalList.js